/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../../common';
import HomeFacadeBlock from './HomeFacadeBlock';
import Banner from './banner/Banner';

const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.home`;

export default class ReadingRoundBlock extends HomeFacadeBlock {
	static initAttrs(attrs) {
		attrs.position = 'reading_round';
	}

	view(vnode) {
		let { banners } = this;

		if (!banners.length) {
			return super.view(vnode);
		}

		// Take the first 3 items
		banners = banners.slice(0, 3);

		return (
			<div className="HomeFacadeBlock ReadingRoundBlock">
				<div className="HomeFacadeBlock-header">
					<h2>{t(`${prfx}.reading_rounds`)}</h2>
				</div>
				<div className="HomeFacadeBlock-body">
					{banners.map((banner) => (
						<Banner banner={banner} ignoreTitle={true} />
					))}
				</div>
			</div>
		);
	}
}
